import { SubprogramService } from '@modules/subprogram/subprogram-service';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    loading: false,
  },

  getters: {
    loading: (state) => !!state.loading,
  },

  mutations: {
    DESTROY_ALL_STARTED(state) {
      state.loading = true;
    },

    DESTROY_ALL_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ALL_ERROR(state) {
      state.loading = false;
    },

    DESTROY_STARTED(state) {
      state.loading = true;
    },

    DESTROY_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ERROR(state) {
      state.loading = false;
    },
  },

  actions: {
    async doDestroy({ commit, dispatch, rootGetters }, {id, propertyId, subpropertyId, programId}) {
      try {
        commit('DESTROY_STARTED');
        // const manageInput = new ManageModel(manage).getManageModel()
        await SubprogramService.destroyAll([id], {type: 'program', propertyId, subpropertyId, programId});

        commit('DESTROY_SUCCESS');

        Message.success(i18n('entities.subprogram.destroy.success'));

        dispatch(
          `${'program/list'}/doFetch`,
          {filter: rootGetters[`${'program/list'}/filter`]},
          {
            root: true,
          },
        );
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ERROR');
      }
    },

    async doDestroyAll(
      { commit, dispatch, rootGetters },
      {ids, manage},
    ) {
      try {
        commit('DESTROY_ALL_STARTED');

        const manageInput = new ManageModel(manage).getManageModel()
        await SubprogramService.destroyAll(ids, manageInput);

        commit('DESTROY_ALL_SUCCESS');

        Message.success(
          i18n('entities.subprogram.destroyAll.success'),
          );

        dispatch(
          `${'program/list'}/doFetch`,
          {filter: rootGetters[`${'program/list'}/filter`]},
          {
            root: true,
          },
        );
        
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ALL_ERROR');
      }
    },
  },
};
